import React from 'react'
import Logo from '../../../../paginas/img/logo.png'


const Login = () => {
    return (
        <div className="Login">

            <div className="contLogin align-self-center text-center container">
                <div className="card-body px-lg-5 pt-0">

                    <img className="Logo_login" src={Logo} />

                    <form className="text-center">

                        <div className="md-form">
                            <input
                                type="text"
                                className="form-control"
                                name="usuario"
                                placeholder="Usuario"
                            />
                        </div>

                        <div className="md-form">
                            <input
                                type="password"
                                className="form-control"
                                name="clave"
                                placeholder="Contraseña"
                            />
                        </div>
                        <p></p>
                        <button type="submit" className="btn boton_estandar btn-rounded btn-block my-4 btn-lg">Ingresar</button>
                        <span>Sede: Admin App</span>
                    </form>


                </div>
            </div>
        </div>
    )
}

export default Login